import { TableV2 } from '@anytag/shared-atoms';
import { YoutubeAnalyticsPostsPayload } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerYoutubeAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsYoutubeVideosListTable } from './hooks';

export interface AnalyticsYoutubeVideosListProps extends TableData<YoutubeAnalyticsPostsPayload> {
  mainSocialAccountId?: number;
}

export const AnalyticsYoutubeVideosList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsYoutubeVideosListProps) => {
  const { columns } = useAnalyticsYoutubeVideosListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerYoutubeAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
